import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { StoreContext } from '../../context/context';
import LoadingAnimation from '../../components/LoadingAnimation';
import StarRating from '../../components/StarRating';
import './Users.css';

class TechnicianPage extends React.Component {
  static contextType = StoreContext;
  userID = 0;

  state = {
    user: {},
  };

  constructor(props) {
    super(props);
    this.userID = this.props.match.params.userID;
  }

  componentDidMount() {
    this.userStore = this.context.userStore;
    this.loadUser(this.userID);
  }

  async loadUser(userID) {
    // If a ticketID was passed, load this
    var user = await this.userStore.getUser(userID);
    this.setState({
      status: 'loaded',
      user: user,
    });
  }

  render() {
    return (
      <div className='pageContainer'>
        {this.state.status === 'loading' ? (
          <LoadingAnimation />
        ) : (
          <Technician user={this.state.user} history={this.props.history} />
        )}
      </div>
    );
  }
}

class Technician extends React.Component {
  static contextType = StoreContext;

  render() {
    var user = this.props.user;
    return (
      <div className='userContainer'>
        <div className='whiteContainer'>
          <div className='userPageHeading'>
            <div
              className='profilePic'
              style={{ backgroundImage: `url("${user.imgUrl}")` }}
            ></div>
            <h1>
              {user.firstname} {user.surname}
            </h1>
          </div>
          <StarRating stars={user.rating} />
          <p>{user.about}</p>
          <button onClick={this.props.history.goBack}>&#8592; Back</button>
        </div>
        <div className='footerContainer'></div>
      </div>
    );
  }
}

// Function wrapper for react-router v6+
function TechnicianPageWrapper(props) {
  const params = useParams();
  const navigate = useNavigate();

  // Create a minimal history-like object for goBack
  const history = {
    goBack: () => navigate(-1),
  };

  // Simulate the old match prop
  const match = { params };

  return <TechnicianPage {...props} match={match} history={history} />;
}

export default TechnicianPageWrapper;
